import { inject } from "aurelia-framework";
import { PLATFORM } from "aurelia-pal";
import {
  ConfiguresRouter,
  Router,
  RouteConfig,
  RouterConfiguration,
} from "aurelia-router";
import { ApplicationState } from "../../services/application-state";

@inject(ApplicationState)
export class ProductfinderIndex implements ConfiguresRouter {
  router: Router;

  constructor(private state: ApplicationState) {}

  configureRouter(config: RouterConfiguration, router: Router) {
    config.map([
      {
        route: "",
        redirect: "input",
      },
      {
        route: "input",
        name: "input",
        moduleId: PLATFORM.moduleName("./productfinder-form"),
        nav: true,
        title: "productfinder.input.title",
        settings: {
          auth: true,
          needsRightOneOf: ["productfinder"],
        },
      },
      {
        route: "output",
        name: "output",
        moduleId: PLATFORM.moduleName("./productfinder-output"),
        nav: true,
        title: "productfinder.output.title",
        settings: {
          auth: true,
          needsRightOneOf: ["productfinder"],
          hidden: this.state.productfinderResult == null,
        },
      },
      {
        route: "offer",
        name: "offer",
        moduleId: PLATFORM.moduleName("./productfinder-offer"),
        nav: true,
        title: "productfinder.offer.title",
        settings: {
          auth: true,
          needsRightOneOf: ["productfinder"],
          hidden:
            this.state.productfinderResult == null ||
            this.state.productfinderResult.error != null,
        },
      },
      {
        route: "downloads",
        name: "downloads",
        moduleId: PLATFORM.moduleName("./productfinder-downloads"),
        nav: true,
        title: "productfinder.downloads.title",
        settings: {
          auth: true,
          needsRightOneOf: ["productfinder"],
        },
      },
      {
        route: "noresult",
        name: "noresult",
        moduleId: PLATFORM.moduleName("./productfinder-noresult"),
        nav: true,
        title: "productfinder.output.error.noresult",
        settings: {
          auth: true,
          needsRightOneOf: ["productfinder"],
          hidden: true,
        },
      },
    ] as RouteConfig[]);

    config.fallbackRoute("input");
    config.mapUnknownRoutes(PLATFORM.moduleName("../notfound"));

    this.router = router;
  }
}
